import { render, staticRenderFns } from "./SmoothScrollPage.vue?vue&type=template&id=12e16834&"
import script from "./SmoothScrollPage.vue?vue&type=script&lang=ts&"
export * from "./SmoothScrollPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports